import DOMPurify from 'isomorphic-dompurify'

export function sanitize(html: string, ALLOWED_TAGS?: string[]) {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS })
}
